import { createSlice } from '@reduxjs/toolkit';
import { inventoryData } from '../../data/inventoryData';

const initialState = {
  inventory: inventoryData,
  loading: false,
  error: null,
  searchTerm: '',
  selectedProduct: null,
};

const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setInventory: (state, action) => {
      state.inventory = action.payload;
    },
    updateStock: (state, action) => {
      const index = state.inventory.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.inventory[index] = action.payload;
      }
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setInventory,
  updateStock,
  setSearchTerm,
  setSelectedProduct,
  setLoading,
  setError,
} = inventorySlice.actions;

export default inventorySlice.reducer;